import React, {useEffect} from "react";
import Highcharts from "highcharts";

require('highcharts/modules/vector')(Highcharts);

export default function ({data, id}) {
    useEffect(() => {
        if (data.length > 0) {
            const options = {
                title: {
                    text: undefined
                },
                xAxis: {
                    gridLineWidth: 1,
                    min: 0,
                    max: 50,
                    labels: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: {
                        text: undefined
                    },
                    labels: {
                        enabled: false
                    }
                },
                plotOptions: {
                    vector: {
                        vectorLength: 130,
                        rotationOrigin: 'start'
                    }
                },
                tooltip: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                series: data.map(item => {
                    return {
                        type: 'vector',
                        name: item.name,
                        data: [
                            [0, 0, 50, 270 - item.angle]
                        ]
                    }
                })
            }
            Highcharts.chart('skill-vector-graph-' + id, options);
        }
    }, [data]);

    function renderEmpty() {
        if (data.length <= 0) {
            return 'No data';
        }

        return null;
    }

    return (
        <div>
            {renderEmpty()}
            <div id={"skill-vector-graph-" + id}/>
        </div>
    );
}
